var render = function render(_c,_vm){return _c('polygon',{attrs:{"points":"5.6,0 3.4,2.1 10.3,9 3.4,15.9 5.6,18 14.6,9 "}})
}
var staticRenderFns = []

export { render, staticRenderFns }